export default __webpack_public_path__ + "static/media/success.4d0c90e8.svg";